//クラスに"onClick"がついていたら、data-elmで指定されているelementに"is-on"クラスをつける
let onhovers = document.querySelectorAll(".onHover");
let notHovers = document.querySelectorAll(".notHover");

onhovers.forEach((onhover) => {
    let elm = document.querySelector("#" + onhover.dataset.elm);

    onhover.addEventListener("mouseenter", () => {
        onhovers.forEach((onhover) => {
            let elm = document.querySelector("#" + onhover.dataset.elm);
            elm.classList.remove("is-on");
        });

        elm.classList.add("is-on");
    });

    document
        .querySelector(onhover.dataset.within)
        .addEventListener("mouseleave", () => {
            //search入力中に消えないように
            if (onhover.dataset.elm === "searchbar") {
                const searchbar = document.querySelector("#searchbar");
                const input = searchbar.querySelector(
                    `.Google-search input[type="text"]`
                );

                if (document.activeElement === input) {
                } else {
                    elm.classList.remove("is-on");
                }
            } else {
                elm.classList.remove("is-on");
            }
        });
});

notHovers.forEach((notHover) => {
    notHover.addEventListener("mouseenter", () => {
        onhovers.forEach((onhover) => {
            let elm = document.querySelector("#" + onhover.dataset.elm);
            elm.classList.remove("is-on");
        });
    });
});
